import { levelKgs } from '@src/data/utils';
import { useSquash } from '@src/hooks/useSquash';
import { HStack, Progress, VStack, Text } from 'ui_2';

export const Level = () => {
  const { activeSquash } = useSquash();

  const kg = activeSquash?.kg ?? 0;
  const level = Math.min(activeSquash?.onChainLevel ?? 0, 4);
  const nextLevelKg = level !== undefined ? levelKgs[level + 1] : undefined;
  const levelKg = (level !== undefined ? levelKgs[level] : 0) ?? 0;

  const levelPercentage =
    level !== undefined && nextLevelKg !== undefined
      ? ((kg - levelKg) / (nextLevelKg - levelKg)) * 100
      : undefined;

  return (
    <VStack className='w-full'>
      <HStack className='w-full justify-between'>
        <Text font='bold-md' family='atak'>
          {level !== undefined ? `LEVEL ${level + 1}` : 'Loading...'}
        </Text>
      </HStack>
      {level !== undefined && <Progress value={levelPercentage} />}
      {level !== undefined && (
        <HStack className='mb-4 mr-1 w-full justify-end'>
          {kg !== undefined && (
            <div className='text-[12px] font-normal'>{kg} / </div>
          )}
          <div className='text-[12px] font-bold'>
            &nbsp;{nextLevelKg}&nbsp;KG
          </div>
        </HStack>
      )}
    </VStack>
  );
};
